<template>
    <div>
        <div v-if="showPage">
            <a-row>
                <a-col :span="1">
                    <a-button type="primary" @click="addData">
                        新增
                    </a-button>
                </a-col>
            </a-row>
            <a-table :columns="columns" :data-source="data.data" bordered :pagination="false" rowKey="id">
                <template slot="operation" slot-scope="text,row">
                    <a style="padding-left:5px;color: green" @click="look(row)">查询</a>
                    <a-divider type="vertical"/>
                    <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                    <a-divider type="vertical"/>
                    <a style="padding-left:5px;color:red" @click="delButton(row)">删除</a>
                </template>
            </a-table>
            <my-page :data="data" @change="onChange"/>
        </div>
        <div v-else>
            <a-row>
                <a-col :span="2">
                    <a-button type="primary" @click="goBack">
                        返回
                    </a-button>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="4">
                    <a style="font-size: 20px;color: aqua">{{line.name}}</a>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    开始时间：
                </a-col>
                <a-col :span="4">
                    <my-date class="input" :date-value.sync="startDt" :placeholder="'开始时间'"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    结束时间：
                </a-col>
                <a-col :span="4">
                    <my-date class="input" :date-value.sync="endDt" :placeholder="'结束时间'"/>
                </a-col>
                <a-col :span="2">
                    <a-button type="primary" @click="selectByDate">
                        查询
                    </a-button>
                </a-col>
            </a-row>
            <a-tabs style="text-align: left;margin-left: 10px;margin-right: 10px" default-active-key="1"
                    @change="changeTab">
                <a-tab-pane key="1" tab="告警">
                    <a-table :columns="columnsAlarm" :data-source="alarm.data" :scroll="{y:'65vh'}" bordered :pagination="false" rowKey="id">
                        <template slot="createDt" slot-scope="text,row">
                            <a style="color: #666666">{{getTime(row.createDt)}}</a>
                        </template>
                    </a-table>
                    <my-page :data="alarm" @change="changeAlarm"/>
                </a-tab-pane>
                <a-tab-pane key="2" tab="事件">
                    <a-table :columns="columnsEvent" :data-source="event.data" :scroll="{y:'65vh'}" bordered :pagination="false" rowKey="id">
                        <template slot="createDt" slot-scope="text,row">
                            <a style="color: #666666">{{getTime(row.createDt)}}</a>
                        </template>
                    </a-table>
                    <my-page :data="event" @change="changeEvent"/>
                </a-tab-pane>
                <a-tab-pane key="3" tab="车辆装载历史">
                    <a-table :columns="columnsLoad" :data-source="load.data" bordered :scroll="{y:'65vh'}" :pagination="false" rowKey="id">
                        <template slot="nowBoxs" slot-scope="text,row">
                            <a style="color: #666666">{{getRfid(row.nowBoxs)}}</a>
                        </template>
                        <template slot="downBoxs" slot-scope="text,row">
                            <a style="color: #666666">{{getRfid(row.downBoxs)}}</a>
                        </template>
                        <template slot="upBoxs" slot-scope="text,row">
                            <a style="color: #666666">{{getRfid(row.upBoxs)}}</a>
                        </template>
                        <template slot="createDt" slot-scope="text,row">
                            <a style="color: #666666">{{getTime(row.createDt)}}</a>
                        </template>
                    </a-table>
                    <my-page :data="load" @change="changeLoad"/>
                </a-tab-pane>
                <a-tab-pane key="4" tab="车辆轨迹">
                    <baidu-map class="map"
                               :center="center"
                               :zoom="16"
                               :scroll-wheel-zoom="true">
                        <bm-polyline
                                v-for="item in location.data"
                                :path="item.deviceLocations"
                                :key="item.car.id"
                                :stroke-color="getRandomColor()"
                                :stroke-opacity="0.5"
                                :stroke-weight="10"/>
                        <bm-marker v-for="row in location.data" :key="row.device.id"
                                   :position="row.device"
                                   shape="BMAP_POINT_SHAPE_RHOMBUS"
                                   size="BMAP_POINT_SIZE_BIGGER">
                            <bm-label :content="row.device.no"
                                      :offset="{width: 0, height: 30}"/>
                        </bm-marker>
                    </baidu-map>
                </a-tab-pane>
                <a-tab-pane key="5" tab="车辆状态变更">
                    <a-table :columns="columnsStatus" :data-source="dispatchStatus.data" :scroll="{y:'65vh'}" bordered :pagination="false" rowKey="id">
                        <template slot="createDt" slot-scope="text,row">
                            <a style="color: #666666">{{getTime(row.createDt)}}</a>
                        </template>
                    </a-table>
                    <my-page :data="dispatchStatus" @change="changeStatus"/>
                </a-tab-pane>
                <a-tab-pane key="6" tab="车辆告警信息">
                    <a-table :columns="columnsDeviceAlarm" :data-source="deviceAlarm.data" :scroll="{y:'65vh'}" bordered :pagination="false" rowKey="id">
                        <template slot="createDt" slot-scope="text,row">
                            <a style="color: #666666">{{getTime(row.createDt)}}</a>
                        </template>
                    </a-table>
                    <my-page :data="deviceAlarm" @change="changeDeviceAlarm"/>
                </a-tab-pane>
                <a-tab-pane key="7" tab="车辆维修记录">
                    <a-table :columns="columnsMaintenance" :data-source="maintenance.data" bordered :pagination="false" rowKey="id">
                        <template slot="createDt" slot-scope="text,row">
                            <a style="color: #666666">{{getTime(row.createDt)}}</a>
                        </template>
                    </a-table>
                    <my-page :data="maintenance" @change="changeMaintenance"/>
                </a-tab-pane>
            </a-tabs>
        </div>
        <a-modal v-model="visible"
                 width="70%"
                 :centered="true"
                 :maskClosable="false"
                 :bodyStyle="modalBodyStyle"
                 title="调度计划管理"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="getData">
            <a-row>
                <a-col :span="1"/>
                <a-col :span="2">
                    序号：
                </a-col>
                <a-col :span="4">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    计划名称：
                </a-col>
                <a-col :span="4">
                    <a-input v-model.trim="form.name"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    告警策略：
                </a-col>
                <a-col :span="4">
                    <my-select :select-value.sync="form.dispatchTacticsId" :data-list="tactics"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 10px">
                <a-col :span="1"/>
                <a-col :span="2">
                    开始时间：
                </a-col>
                <a-col :span="4">
                    <my-date class="input" :date-value.sync="form.startDt"/>
                </a-col>
                <a-col :span="1"/>
                <a-col :span="2">
                    结束时间：
                </a-col>
                <a-col :span="4">
                    <my-date class="input" :date-value.sync="form.endDt"/>
                </a-col>
            </a-row>
            <a-row style="margin-top: 30px">
                <a-col :span="3">
                    <strong style="font-size: 20px">明细信息</strong>
                </a-col>
                <a-col :span="19"/>
                <a-col :span="2">
                    <a-button style="float: right" type="primary" @click="addLine">
                        新增
                    </a-button>
                </a-col>
            </a-row>
            <a-divider style="margin: 5px 0"/>
            <a-table :columns="columnsChildren"
                     size="small"
                     :scroll="{y:'38vh'}"
                     :data-source="form.dispatchDetails"
                     :pagination="false"
                     rowKey="id">
                <template slot="orderNo" slot-scope="text, record">
                    <a-input-number style="width: 100%" v-model.trim="record.orderNo"/>
                </template>
                <template slot="organId" slot-scope="text, record">
                    <my-select :select-value.sync="record.organId" :data-list="org"/>
                </template>
                <template slot="operation" slot-scope="text, record">
                    <a style="color: red" @click="deleteLine(record)">{{record.isDel==='1'?'已删除':'删除'}}</a>
                </template>
            </a-table>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {
        getDispatchList,
        dispatchEditDetail,
        dispatchDelDetail,
        getDispatchTacticsList,
        queryDispatchAlarmList,
        queryDispatchEventList,
        queryDispatchLoadList,
        queryDispatchLocationList,
        queryDispatchStatusList,
        queryDispatchDeviceAlarmList,
        queryDispatchMaintenanceList
    } from './js/ApiDispatch';
    import {getNowDateString, modalBodyStyle,getRandomColor} from "../../config/Config"
    import {getOrgQueryList} from "../basic/js/ApiBasic";

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '计划名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '计划开始时间',
            dataIndex: 'startDt',
            key: 'startDt',
            ellipsis: true,
        },
        {
            title: '计划结束时间',
            dataIndex: 'endDt',
            key: 'endDt',
            ellipsis: true,
        },
        // 20201102不需要暂屏蔽
        // {
        //     title: '设备Id',
        //     dataIndex: 'deviceId',
        //     key: 'deviceId',
        //     ellipsis: true,
        // },
        {
            title: '调度计划告警策略',
            dataIndex: 'dispatchTactics.descpt',
            key: 'dispatchTactics.descpt',
            ellipsis: true,
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '180px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    const columnsChildren = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
            scopedSlots: {customRender: 'orderNo'},
        },
        {
            title: '机构',
            dataIndex: 'organId',
            key: 'organId',
            ellipsis: true,
            scopedSlots: {customRender: 'organId'},
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: '120px',
            align: 'center',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    const columnsAlarm = [
        {
            title: '车牌号',
            dataIndex: 'car.carNo',
            key: 'car.carNo',
            ellipsis: true,
        },
        {
            title: '告警名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '告警信息',
            dataIndex: 'msg',
            key: 'msg',
            ellipsis: true,
        },
        {
            title: '创建时间',
            dataIndex: 'createDt',
            key: 'createDt',
            ellipsis: true,
            scopedSlots: {customRender: 'createDt'},
        },
        {
            title: '告警级别',
            dataIndex: 'level',
            key: 'level',
            ellipsis: true,
        },
    ];
    const columnsEvent = [
        {
            title: '事件名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '事件级别',
            dataIndex: 'level',
            key: 'level',
            ellipsis: true,
        },
        {
            title: '事件信息',
            dataIndex: 'msg',
            key: 'msg',
            ellipsis: true,
        },
        {
            title: '经度',
            dataIndex: 'lng',
            key: 'lng',
            ellipsis: true,
        },
        {
            title: '纬度',
            dataIndex: 'lat',
            key: 'lat',
            ellipsis: true,
        },
        {
            title: '时间',
            dataIndex: 'createDt',
            key: 'createDt',
            ellipsis: true,
            scopedSlots: {customRender: 'createDt'},
        },
        {
            title: '医疗机构',
            dataIndex: 'organ.name',
            key: 'organ.name',
            ellipsis: true,
        },
        {
            title: '地址',
            dataIndex: 'organ.address',
            key: 'organ.address',
            ellipsis: true,
        },
    ];
    const columnsLoad = [
        {
            title: '车牌号',
            dataIndex: 'car.carNo',
            key: 'car.carNo',
            width: '7%',
            ellipsis: true,
        },
        {
            title: '当前周转箱',
            dataIndex: 'nowBoxs',
            key: 'nowBoxs',
            width: '15%',
            scopedSlots: {customRender: 'nowBoxs'},
        },
        {
            title: '下车周转箱',
            dataIndex: 'downBoxs',
            key: 'downBoxs',
            width: '15%',
            scopedSlots: {customRender: 'downBoxs'},
        },
        {
            title: '上车周转箱',
            dataIndex: 'upBoxs',
            key: 'upBoxs',
            width: '15%',
            scopedSlots: {customRender: 'upBoxs'},
        },
        {
            title: '经度',
            dataIndex: 'lng',
            key: 'lng',
            width: '7%',
            ellipsis: true,
        },
        {
            title: '纬度',
            dataIndex: 'lat',
            key: 'lat',
            width: '7%',
        },
        {
            title: '时间',
            dataIndex: 'createDt',
            key: 'createDt',
            width: '14%',
            scopedSlots: {customRender: 'createDt'},
        },
        {
            title: '医疗机构',
            dataIndex: 'organ.name',
            key: 'organ.name',
            width: '9%',
        },
        {
            title: '地址',
            dataIndex: 'organ.address',
            key: 'organ.address',
            width: '11%',
        },
    ];
    const columnsStatus = [
        {
            title: '车牌号',
            dataIndex: 'car.carNo',
            key: 'car.carNo',
        },
        {
            title: '设备编号',
            dataIndex: 'device.no',
            key: 'device.no',
        },
        {
            title: '变更前状态',
            dataIndex: 'oldStatus',
            key: 'oldStatus',
        },
        {
            title: '当前状态',
            dataIndex: 'nowStatus',
            key: 'nowStatus',
        },
        {
            title: '时间',
            dataIndex: 'createDt',
            key: 'createDt',
            width: '165px',
            scopedSlots: {customRender: 'createDt'},
        },
        {
            title: '医疗机构',
            dataIndex: 'organ.name',
            key: 'organ.name',
        },
        {
            title: '地址',
            dataIndex: 'organ.address',
            key: 'organ.address',
        },
    ];
    const columnsDeviceAlarm = [
        {
            title: '车牌号',
            dataIndex: 'car.carNo',
            key: 'car.carNo',
        },
        {
            title: '设备编号',
            dataIndex: 'device.no',
            key: 'device.no',
        },
        {
            title: '设备状态',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: '告警信息',
            dataIndex: 'msg',
            key: 'msg',
        },
        {
            title: '告警类型',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: '是否在线',
            dataIndex: 'onLine',
            key: 'onLine',
        },
        {
            title: '时间',
            dataIndex: 'createDt',
            key: 'createDt',
            width: '165px',
            scopedSlots: {customRender: 'createDt'},
        },
        {
            title: '地址',
            dataIndex: 'organ.address',
            key: 'organ.address',
        },
    ];
    const columnsMaintenance = [
        {
            title: '车牌号',
            dataIndex: 'car.carNo',
            key: 'car.carNo',
        },
        {
            title: '维修地址',
            dataIndex: 'address',
            key: 'address',
        },
        {
            title: '维修公司',
            dataIndex: 'compy',
            key: 'compy',
        },
        {
            title: '维修内容',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '维修电话',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: '维修前状态',
            dataIndex: 'oldStatus',
            key: 'oldStatus',
        },
        {
            title: '维修后状态',
            dataIndex: 'nowStatus',
            key: 'nowStatus',
        },
        {
            title: '时间',
            dataIndex: 'createDt',
            key: 'createDt',
            width: '165px',
            scopedSlots: {customRender: 'createDt'},
        },
    ];
    export default {
        data() {
            return {
                columns,
                columnsChildren,
                columnsAlarm,
                columnsEvent,
                columnsLoad,
                columnsStatus,
                columnsDeviceAlarm,
                columnsMaintenance,
                modalBodyStyle,
                showPage: true,
                visible: false,
                delVisible: false,
                conditionList: [],
                data: {},
                startDt: getNowDateString(),
                endDt: getNowDateString(),
                lines: {},
                org: [],
                tactics: [],
                form: {
                    orderNo: '',
                    name: '',
                    startDt: '',
                    endDt: '',
                    deviceId: '',
                    dispatchTacticsId: '',
                    dispatchDetails: []
                },
                // 查询显示的信息
                tab: '1',// 当前哪一个页签
                center: {},
                line: {},// 查询的行
                alarm: {},// 告警历史
                event: {},// 事件历史
                load: {},//装载历史
                location: {},// 车辆轨迹
                dispatchStatus: {},// 车辆状态变更历史
                deviceAlarm: {},//车辆告警历史
                maintenance: {},// 车辆维修记录
            }
        },
        methods: {
            getRandomColor,
            // 新增按钮
            addData() {
                this.visible = true;
            },
            //新增-点击确定
            add() {
                this.form.orderNo = this.form.orderNo + '';
                this.form.dispatchDetails.forEach(item=>{
                    item.orderNo = item.orderNo + ''
                });
                dispatchEditDetail(this.form).then(() => {
                    this.visible = false;
                    this.getData()
                }).catch(res => {
                    this.visible = false;
                    console.log(res)
                })
            },
            // 编辑按钮
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            // 删除按钮
            delButton(row) {
                this.lines = row;
                this.delVisible = true;
            },
            // 删除提示确认
            delOk() {
                this.delVisible = false;
                dispatchDelDetail({id: this.lines.id}).then(() => {
                    this.getData();
                });
            },
            // 删除提示取消
            cancel() {
                this.delVisible = false;
            },
            // 获取数据
            getData(parameter) {
                if (!parameter) {
                    parameter = {}
                }
                this.resetForm();
                this.visible = false;
                getDispatchList(parameter).then(res => {
                    this.data = res.data;
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                this.form = {
                    orderNo: '',
                    name: '',
                    startDt: '',
                    endDt: '',
                    deviceId: '',
                    dispatchTacticsId: '',
                    dispatchDetails: [],
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                this.getData({baseDto: baseDto});
            },
            changeAlarm(page){
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getAlarm({id: this.line.id,baseDto: baseDto});
            },
            changeEvent(page){
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getEvent({id: this.line.id,baseDto: baseDto});
            },
            changeLoad(page){
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getLoad({id: this.line.id,baseDto: baseDto});
            },
            changeStatus(page){
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getStatus({id: this.line.id,baseDto: baseDto});
            },
            changeDeviceAlarm(page){
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getDeviceAlarm({id: this.line.id,baseDto: baseDto});
            },
            changeMaintenance(page){
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getMaintenance({id: this.line.id,baseDto: baseDto});
            },
            // 新增空行
            addLine() {
                this.form.dispatchDetails.push({dispatchId: this.form.id});
            },
            // 删除行
            deleteLine(row) {
                row.isDel = '1';
                let index = this.form.dispatchDetails.findIndex(item => {
                    return item === row
                });
                this.form.dispatchDetails.splice(index, 1)
            },
            // 查询详情
            look(row) {
                this.showPage = !this.showPage;
                this.line = row;
                this.selectAlarm(row)
            },
            // 查询告警
            selectAlarm(row) {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getAlarm({id: row.id,baseDto: baseDto});
            },
            getAlarm(parameter){
                queryDispatchAlarmList(parameter).then(res => {
                    this.alarm = res.data;
                })
            },
            // 查询事件
            selectEvent(row) {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getEvent({id: row.id,baseDto: baseDto});
            },
            getEvent(parameter){
                queryDispatchEventList(parameter).then(res => {
                    this.event = res.data;
                })
            },
            // 查询装载历史
            selectLoad(row) {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getLoad({id: row.id,baseDto: baseDto});
            },
            getLoad(parameter){
                queryDispatchLoadList(parameter).then(res => {
                    this.load = res.data;
                })
            },
            // 查询车辆轨迹
            selectLocation(row) {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                queryDispatchLocationList({id: row.id,baseDto: baseDto}).then(res => {
                    this.location = res.data;
                    this.center = res.data.data[0].device
                })
            },
            // 查询车辆状态变更历史
            selectDispatchStatus(row) {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getStatus({id: row.id,baseDto: baseDto});
            },
            getStatus(parameter){
                queryDispatchStatusList(parameter).then(res => {
                    this.dispatchStatus = res.data;
                })
            },
            // 查询车辆告警历史
            selectDeviceAlarm(row) {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getDeviceAlarm({id: row.id,baseDto: baseDto});
            },
            getDeviceAlarm(parameter){
                queryDispatchDeviceAlarmList(parameter).then(res => {
                    this.deviceAlarm = res.data;
                })
            },
            // 查询车辆维修记录
            selectMaintenance(row) {
                let baseDto = {
                    queryStartDate: this.startDt,
                    queryEndDate: this.endDt
                };
                this.getMaintenance({id: row.id,baseDto: baseDto});
            },
            getMaintenance(parameter){
                queryDispatchMaintenanceList(parameter).then(res => {
                    this.maintenance = res.data;
                })
            },
            // 页面改时间显示
            getTime(date) {
                return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
            },
            // 页面改周转箱显示
            getRfid(list) {
                let str = '';
                if(list){
                    list.forEach(item=>{
                        str = str + item.rfidNo + ', '
                    })
                }
                return str
            },
            // 返回首页
            goBack() {
                this.showPage = !this.showPage;
            },
            // 根据时间查询按钮
            selectByDate(){
                this.changeTab(this.tab);
            },
            // 切换页签
            changeTab(key) {
                switch (key) {
                    case '1':
                        this.tab = key;
                        this.selectAlarm(this.line);
                        break;
                    case '2':
                        this.tab = key;
                        this.selectEvent(this.line);
                        break;
                    case '3':
                        this.tab = key;
                        this.selectLoad(this.line);
                        break;
                    case '4':
                        this.tab = key;
                        this.selectLocation(this.line);
                        break;
                    case '5':
                        this.tab = key;
                        this.selectDispatchStatus(this.line);
                        break;
                    case '6':
                        this.tab = key;
                        this.selectDeviceAlarm(this.line);
                        break;
                    case '7':
                        this.tab = key;
                        this.selectMaintenance(this.line);
                        break;
                }
            }
        },
        created() {
            this.getData();
            getOrgQueryList({}).then(res => {
                this.org = res.data.data;
            });
            getDispatchTacticsList({}).then(res => {
                this.tactics = res.data.data;
                this.tactics.forEach(item => {
                    item.name = item.descpt
                })
            })
        }
    }
</script>

<style scoped>
    .Tips {
        font-size: 25px;
        color: #1890ff;
    }
    .map {
        width: 100%;
        height: 77vh;
    }
</style>
